// extracted by mini-css-extract-plugin
export default {"errorFallback":"esqIvNZKZ7BAHvkvX2YVgCMpRqezi_ut"};